import { memo } from 'react';

import { OPopper } from '@src/shared';
import Timer from '@src/components/Timer';
import OptionDropdown from '../OptionDropdown';

import useViewPolls from './useViewPolls';

import { FaUsers } from 'react-icons/fa';
import { BiDotsVerticalRounded } from 'react-icons/bi';

const ViewPolls = () => {
  const {
    polls,
    canUserCreatePoll,
    singleVotesCounter,
    isMenuPopperOpened,
    isPollDeleteButtonEnabled,

    handleSingleVote,
    handleDeletePoll,
    handleOnMenuClick,
    handleMultipleVotes,
    handlePollTimeLimit,
    getOptionVotersData,
  } = useViewPolls();

  return (
    <div className="view-polls-container">
      {polls.length ? (
        polls.map(({ id, options, question, voteType, closingTime = 'none', createdAt, isVoteClosed }, pollIndex) => (
          <div className="poll-container" key={`${id}-${pollIndex}`}>
            <div className="poll-info">
              <div className="header-box">
                <div className="action-label">
                  <label className="label">Poll {pollIndex + 1}:</label>
                  {/* NOTE: change it when add more options */}
                  {(canUserCreatePoll || isPollDeleteButtonEnabled) && (
                    <OPopper
                      icon={
                        <div className={`icon-container ${isMenuPopperOpened[id] ? 'active' : ''}`}>
                          <BiDotsVerticalRounded size={24} />
                        </div>
                      }
                      position="bottom-start"
                      onClose={() => handleOnMenuClick(id, false)}
                      onOpen={() => handleOnMenuClick(id, true)}
                      isActive={isMenuPopperOpened[id]}
                    >
                      <div className="action-box-menu">
                        <div className="menu-item" onClick={() => handleDeletePoll(id, pollIndex)}>
                          Delete
                        </div>
                      </div>
                    </OPopper>
                  )}
                </div>
                {closingTime !== 'none' && (
                  <Timer
                    duration={closingTime}
                    referenceTime={createdAt}
                    onTimeFinish={() => handlePollTimeLimit(id)}
                    title="Poll timer"
                  />
                )}
              </div>
              <label className="title">{question}</label>
            </div>
            <div className="polls-votes-container">
              {!!options?.length &&
                options.map((option, optionIndex) => {
                  const { count, optionVoters, percentage, isUserVoted, hasVotes } = getOptionVotersData(
                    pollIndex,
                    optionIndex
                  );
                  const isDisabled = !!isVoteClosed || (singleVotesCounter.get(id) || 0) >= 4;

                  return (
                    <OptionDropdown
                      key={optionIndex}
                      label={option}
                      optionIcon={hasVotes ? <FaUsers size={18} /> : undefined}
                      isDropdownHidden={!optionVoters.length}
                      dropdownLabel={count ? `(${count})` : 'No responses yet'}
                      percentage={hasVotes ? percentage : undefined}
                      type={voteType || 'SINGLE'}
                      isChecked={isUserVoted}
                      isDisabled={isDisabled}
                      dropdownText={optionVoters.join(', ')}
                      onOptionClick={() =>
                        voteType === 'SINGLE'
                          ? handleSingleVote(pollIndex, id, option)
                          : handleMultipleVotes(pollIndex, id, option)
                      }
                    />
                  );
                })}
            </div>
          </div>
        ))
      ) : (
        <div className="polls-empty-state">
          <span className="polls-empty-state_message">No polls available</span>
        </div>
      )}
    </div>
  );
};

export default memo(ViewPolls);
